import { Component, OnInit } from '@angular/core';
import { QuestionService } from 'src/app/service/question.service';
import { AnswerService } from 'src/app/service/answer.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-multiple-choice-multiple-select',
  templateUrl: './multiple-choice-multiple-select.component.html',
  styleUrls: ['./multiple-choice-multiple-select.component.scss']
})
export class MultipleChoiceMultipleSelectComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:[],
  }
  public slicedTabOption:any = {
    'options':[],
    'tabCount':0
  }
  public isSwitchTab:boolean = false;
  public componentType:string = "";
  constructor(
    public qService:QuestionService,
    public aService:AnswerService,
    public notifier:NotifierService,
  ) { 
    this.componentType = this.qService.questionType.MULTIPLE_CHOICE_MULTI_SELECT
    this.qService.refreshAnsBody
    .subscribe((question_type:string) =>{
      if (question_type == this.componentType) {
        this.resetAnsBody();
      }
    })
  }

  ngOnInit(): void {
    if (this.qService.questionView.isImgOption) {
      this.getSlicedOption();
    }
  }

  

  multiOptionsSwitch(text:any){
    let find_val = this.ansBody.answer_text.findIndex((va:any) => va.id === text.id);
    if(find_val != -1){
      this.ansBody.answer_text.splice(find_val,1);
    }
    else
    {
      this.ansBody.answer_text.push(text);
    }
    // console.log(this.ansBody);
    // console.log(this.ansBody.answer_text);
  }

  checkedElement(text:any){
    let find_val = this.ansBody.answer_text.find((va:any) => va.id === text.id);
    if(find_val){
      return 1;
    }
    return 0;
  }

  next(){
    // console.log(this.ansBody)
    if (!this.ansBody.answer_text.length) {
      this.notifier.notify('error',"Please select atleast one value");
    }
    else
    {
      this.ansBody.question_label = this.qService.currentQuestion.question_label;
      this.ansBody.question_name = this.qService.currentQuestion.question_name;
      this.aService.submitAnswer(this.ansBody);
      // setTimeout(() => {
      //   this.resetAnsBody();
      // }, 100);
      // console.log(this.qService.finalAnswers);
    }
  }

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:[],
    }
    this.slicedTabOption = {
      'options':[],
      'tabCount':0
    }
 
    var ele = document.getElementById('focus-row');
    if (ele) {
      ele.scrollIntoView();
    }
    if (this.qService.questionView.isImgOption) {
      this.getSlicedOption();
    }
  }

  getSlicedOption(){
    this.isSwitchTab = true;
    let totalTabs = Math.ceil(this.qService.currentQuestion.options.length / this.qService.questionView.optionSize);
    this.slicedTabOption.options = this.qService.currentQuestion.options.slice(this.slicedTabOption.tabCount*this.qService.questionView.optionSize,(this.slicedTabOption.tabCount + 1)*this.qService.questionView.optionSize);
    this.slicedTabOption.tabCount++;
    if (this.slicedTabOption.tabCount == totalTabs) {
      this.isSwitchTab = false;

    }
  }


}
